"use strict";

exports.__esModule = true;

exports.default = function (response) {
  if (!response) {
    return {};
  }

  var responseObj = {
    headers: {},
    status: response.status,
    statusText: response.statusText,
    ok: response.ok
  };

  if (response.headers.entries) {
    var gen = response.headers.entries();

    var header = null;
    do {
      header = gen.next();
      if (header.value) {
        responseObj.headers[header.value[0]] = header.value[1];
      }
    } while (header.done === false);
  }

  return responseObj;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/responseToObject.js
// module id = 345
// module chunks = 0